<template>
  <el-dialog
    title="Details"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    class="dialog-form"
    width="50%"
  >
    <p class="contentCls">{{content}}</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">cancle</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["dialogVisible", "content"], //falg判断是联系人、负责人

  data() {
    return {
      dialogFormVisible: false
    };
  },
  methods: {
    handleClose() {
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    }
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    }
  }
};
</script>

<style scoped>
.contentCls {
  height: 200px;
  overflow-y: auto;
  font-size: 16px;
  line-height: 26px;
}
</style>